<template>
  <div class="signature-pad">
    <canvas ref="canvas" @mousedown="startDrawing" @mousemove="draw" @mouseup="stopDrawing" @mouseleave="stopDrawing"></canvas>
    <div class="actions">
      <button @click="clear">清除</button>
      <button @click="save">保存</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SignaturePad',
  data() {
    return {
      isDrawing: false,
      lastX: 0,
      lastY: 0,
      dpr: window.devicePixelRatio || 1 // 设备像素比
    }
  },
  methods: {
    // 调整画布大小
    resizeCanvas() {
      const canvas = this.$refs.canvas

      // 获取画布的显示尺寸
      const rect = canvas.getBoundingClientRect()

      // 设置画布的实际尺寸与显示尺寸一致
      canvas.width = rect.width
      canvas.height = rect.height

      // 重新设置绘图样式
      const ctx = canvas.getContext('2d')
      ctx.strokeStyle = '#000'
      ctx.lineWidth = 2
      ctx.lineCap = 'round'
      ctx.lineJoin = 'round' // 添加线条连接样式，提高绘图质量
    },
    // 获取鼠标在画布上的位置（兼容不同浏览器）
    getMousePos(canvas, evt) {
      const rect = canvas.getBoundingClientRect()
      return {
        x: evt.clientX - rect.left,
        y: evt.clientY - rect.top
      }
    },

    startDrawing(e) {
      e.preventDefault();  // 阻止默认行为
      this.isDrawing = true
      const canvas = this.$refs.canvas

      // 使用兼容方法获取鼠标位置
      const pos = this.getMousePos(canvas, e)
      this.lastX = pos.x
      this.lastY = pos.y
    },

    draw(e) {
      if (!this.isDrawing) return
      e.preventDefault() // 阻止默认行为，防止在某些浏览器中出现问题

      const canvas = this.$refs.canvas
      const ctx = canvas.getContext('2d')

      // 使用兼容方法获取鼠标位置
      const pos = this.getMousePos(canvas, e)
      const currentX = pos.x
      const currentY = pos.y

      ctx.beginPath()
      ctx.moveTo(this.lastX, this.lastY)
      ctx.lineTo(currentX, currentY)
      ctx.stroke()

      this.lastX = currentX
      this.lastY = currentY
    },
    stopDrawing() {
      this.isDrawing = false
    },
    clear() {
      const canvas = this.$refs.canvas
      const ctx = canvas.getContext('2d')
      ctx.clearRect(0, 0, canvas.width, canvas.height)
    },
    save() {
      const canvas = this.$refs.canvas
      // 检查画布是否为空
      const blankCanvas = document.createElement('canvas')
      blankCanvas.width = canvas.width
      blankCanvas.height = canvas.height
      const isBlank = canvas.toDataURL() === blankCanvas.toDataURL()
      if (isBlank) {
        this.$message({
          message: '请先签名',
          type: 'warning'
        })
        return
      }
      const dataURL = canvas.toDataURL('image/png')
      this.$emit('save', dataURL)
    }
  },
  mounted() {
    // 延迟执行resizeCanvas，确保DOM完全加载
    this.$nextTick(() => {
      this.resizeCanvas()
    })

    // 添加窗口大小变化监听
    window.addEventListener('resize', () => {
      // 使用防抖处理resize事件
      clearTimeout(this.resizeTimer)
      this.resizeTimer = setTimeout(() => {
        this.resizeCanvas()
      }, 200)
    })
  },
  beforeDestroy() {
    // 移除事件监听，防止内存泄漏
    window.removeEventListener('resize', this.resizeCanvas)
    clearTimeout(this.resizeTimer)
  }
}
</script>

<style scoped>
.signature-pad {
  /* border: 1px solid #ccc; */
  padding-top: 2%;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
}
canvas {
  border: 1px solid #ddd;
  background-color: #f9f9f9;
  width: 100%;
  height: 300px;
  user-select: none;
  -webkit-user-select: none;
  display: block; /* 确保画布正确显示 */
}
.actions {
  margin-top: 10px;
}
button {
  margin-right: 10px;
  padding: 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/SignaturePad.vue